import React from 'react';
import img from '../images/web-dev-image.svg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Intro = () => {
    const { t } = useTranslation();

    const points = [t('intro.description1'), t('intro.description2')];

    return (
        <section className="bg-white py-20 lg:py-28" id="about">
            <div className="container-x grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
                <div className="relative order-2 lg:order-1" data-aos="fade-up">
                    <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-brand-50 to-slatex-50 -z-10" />
                    <div className="rounded-2xl border border-slatex-200 bg-white p-6 shadow-card">
                        <img alt="Custom software development" className="w-full" src={img} />
                    </div>
                </div>

                <div className="order-1 lg:order-2" data-aos="fade-up" data-aos-delay="150">
                    <span className="eyebrow">{t('ui.eyebrowIntro')}</span>
                    <h2 className="mt-3 text-3xl md:text-4xl font-extrabold text-ink leading-tight">{t('intro.title')}</h2>
                    <ul className="mt-6 space-y-4">
                        {points.map((p, i) => (
                            <li key={i} className="flex gap-3">
                                <span className="mt-1 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-brand-50 text-brand-600">
                                    <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
                                </span>
                                <p className="text-slatex-600 leading-relaxed">{p}</p>
                            </li>
                        ))}
                    </ul>
                    <Link to="/contact" className="btn-primary mt-8 group">
                        {t('intro.contactButton')}
                        <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Intro;
